<template>
  <div v-if="isEmpty">
    <div v-if="userOnboardingStatus === 'NO_SERVICE'" class="board__empty">
      <v-icon color="grey lighten-2">
        mdi-numeric-1-circle-outline
      </v-icon>
      <p class="board__empty-title grey--text">
        {{ $t('board.emptyState.title') }}
      </p>
      <v-btn @click="callAppointmentModal" color="primary" elevation="0">
        {{ $t('board.emptyState.createAppointment') }}
      </v-btn>
    </div>
    <div class="board__empty" v-else>
      <EmptyState />
    </div>
  </div>
</template>

<script>
import { getUser } from '@/services/auth/user'
import EmptyState from '@/components/app/EmptyState'

export default {
  name: 'BoardColumnEmptyState',

  components: {
    EmptyState,
  },

  props: {
    isEmpty: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    callAppointmentModal() {
      const boardComponent = this.$parent.$parent.$refs.createAppointmentModal
      const createModal = boardComponent.$refs.createModal
      createModal.dialog = true
    },
  },

  data() {
    return {
      userOnboardingStatus: null,
    }
  },

  mounted() {
    Promise.resolve(getUser(true)).then(() => {
      this.userOnboardingStatus = localStorage.getItem('users_onboard_status')
    })
  },
}
</script>
